var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "msg-view__status-bar" }, [
    _c("img", {
      staticClass: "msg-view__status-bar__icon",
      attrs: { src: "/assets/img/icons/icon-info.svg" }
    }),
    _vm._v(" "),
    _c("p", {
      staticClass: "msg-view__status-bar__text",
      domProps: { innerHTML: _vm._s(_vm.message) }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a0c9eb0", { render: render, staticRenderFns: staticRenderFns })
  }
}